<script>
    export default {
        name: "BaseTooltip",
        props: {
            /** @type {import('vue').PropOptions<"left" | "right">} */
            positionX: {
                type: String,
                validator: (v) => ["left", "right"].includes(v),
                default: "left",
            },
            /** @type {import('vue').PropOptions<"top" | "bottom">} */
            positionY: {
                type: String,
                validator: (v) => ["top", "bottom"].includes(v),
                default: "top",
            },
        },
        computed: {
            computeClassNames() {
                return [
                    `base-tooltip--${this.positionX}`,
                    `base-tooltip--${this.positionY}`,
                ].filter(Boolean);
            },
        },
    };
</script>

<template>
    <div class="base-tooltip" :class="computeClassNames">
        <div class="base-tooltip__text">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
    .base-tooltip {
        position: absolute;
        z-index: 10;
        display: none;
        max-width: 200px;
        padding: 11px 15px;
        color: var(--primary-text);
        font-size: var(--base-tooltip-size);
        line-height: 16px;
        text-align: center;
        background-color: #fff;
        border-radius: var(--base-tooltip-radius);
        box-shadow: 0 8px 15px #c7c9d9;
        &::before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 9px 6.5px 0 6.5px;
            border-color: #fff transparent transparent transparent;
        }
    }

    .base-tooltip__text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
    }

    .base-tooltip--top {
        bottom: calc(100% + 12px);
        &::before {
            bottom: -7px;
        }
    }

    .base-tooltip--bottom {
        top: calc(100% + 12px);
        &::before {
            top: -7px;
            transform: rotate(180deg);
        }
    }

    .base-tooltip--left {
        left: calc(50% - 22px);
        &::before {
            left: 15px;
        }
    }

    .base-tooltip--right {
        right: calc(50% - 22px);
        &::before {
            right: 15px;
        }
    }
</style>
